import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "questionnaire-list-container" }
const _hoisted_2 = { class: "questionnaire-list" }
const _hoisted_3 = { class: "row-level1" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "row-level2" }
const _hoisted_10 = { class: "radio" }
const _hoisted_11 = ["name", "id", "onChange", "checked"]
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "progress-container" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["onSubmit"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("small", null, "z.B. Mast 2023", -1)

import {computed, ref, watch} from "vue";
import QuestionnaireReleaseEntity from "@/db/QuestionnaireReleaseEntity";
import getDb from "@/db/Database";
import QuestionnaireEntity from "@/db/QuestionnaireEntity";
import UserQuestionnaireEntity from "@/db/UserQuestionnaireEntity";
import UserQuestionnaire from "@/api/types/UserQuestionnaire";
import Questionnaire from "@/api/types/Questionnaire";
import {ICON_ADD, ICON_ARROW_DOWN, ICON_ARROW_RIGHT, ICON_TRASH} from "@/lib/icons";
import AppAlert from "@/components/AppAlert.vue";
import QuestionnaireRelease from "@/api/types/QuestionnaireRelease";
import emitter from "@/lib/eventBus";
import {useStore} from "vuex";
import {useRouter} from "vue-router";

type DataType = Questionnaire & {
  release: QuestionnaireRelease
  userQuestionnaires: UserQuestionnaire[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionnaireList',
  props: {
    mode: {},
    releaseId: {},
    questionnaireId: {},
    userQuestionnaireId: {}
  },
  emits: [
  'update:releaseId',
  'update:questionnaireId',
  'update:userQuestionnaireId'
],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = useStore()
const router = useRouter()

const data = ref<DataType[]>([])

const expandedQuestionnaireId = ref<number|null>(null)
const selectedReleaseId = ref<number|null>(null)
const selectedUserQuestionnairePk = ref<number|null>(null)

const selectedLocationId = computed<number>(() => store.state.selectedLocationId)

const promptForNewItem = ref<boolean>(false)
const newItemName = ref<string>('')

const toggleExpandedQuestionnaire = (releaseId: number, questionnaireId: number) => {
  selectedUserQuestionnairePk.value = null

  if (questionnaireId === expandedQuestionnaireId.value) {
    selectedReleaseId.value = null
    expandedQuestionnaireId.value = null
  } else {
    selectedReleaseId.value = releaseId
    expandedQuestionnaireId.value = questionnaireId
  }
}

const promptNewItem = (releaseId: number, questionnaireId: number) => {
  selectedReleaseId.value = releaseId
  expandedQuestionnaireId.value = questionnaireId
  selectedUserQuestionnairePk.value = null
  promptForNewItem.value = true
}

const cancelNewItem = () => {
  promptForNewItem.value = false
  newItemName.value = ''
}

const addNewItem = async () => {
  const newUserQuestionnaire = new UserQuestionnaire({
    progress: 0,
    state: 1,
    description: newItemName.value,
    releaseId: selectedReleaseId.value,
    locationId: store.state.selectedLocationId,
    dirty: true
  } as UserQuestionnaire)

  const newItem = await UserQuestionnaireEntity.persist(getDb(), newUserQuestionnaire)

  promptForNewItem.value = false
  newItemName.value = ''

  if (newItem && selectedReleaseId.value) {
    await load()

    // @ts-ignore
    const questionnaire = await UserQuestionnaireEntity.findByPk(getDb(), newItem.pk)
    const release = await QuestionnaireReleaseEntity.find(getDb(), selectedReleaseId.value)
    store.commit('SET_QUESTIONNAIRE', { questionnaire, release })
    await router.push({ name: 'categoryFilter' });
  }
}

const removeItem = async (pk: number|null) => {
  if (pk) {
    await UserQuestionnaireEntity.updateByPk(getDb(), pk, {
      dirty: 1,
      deleted: 1,
    })

    if (pk === selectedUserQuestionnairePk.value) {
      selectedUserQuestionnairePk.value = null
    }

    await load()
  }
}

const onRadioChange = (e: any, pk: number|null) => {
  if (e.target.checked) {
    selectedUserQuestionnairePk.value = pk
  }
}

const load = async () => {
  console.log('load', selectedLocationId.value)
  const releases = await QuestionnaireReleaseEntity.getAll(getDb())

  const res = []
  for (const release of releases) {
    const questionnaire = <DataType>await QuestionnaireEntity.find(getDb(), release.questionnaireId)

    if (questionnaire) {
      const userQuestionnaires = props.mode === 'check'
        ? await UserQuestionnaireEntity.getForCheckByRelease(getDb(), release.id, store.state.selectedLocationId)
        : await UserQuestionnaireEntity.getForReportByRelease(getDb(), release.id, store.state.selectedLocationId)

      userQuestionnaires?.sort((a, b) => a.description > b.description ? 1 : -1)

      questionnaire.release = release
      questionnaire.userQuestionnaires = <UserQuestionnaire[]>userQuestionnaires

      res.push(questionnaire)
    }
  }

  data.value = res
}

emitter.on('RELEASES_LOADED', load)

watch(selectedReleaseId, () => emit('update:releaseId', selectedReleaseId.value))
watch(expandedQuestionnaireId, () => emit('update:questionnaireId', expandedQuestionnaireId.value))
watch(selectedUserQuestionnairePk, () => emit('update:userQuestionnaireId', selectedUserQuestionnairePk.value))
watch(selectedLocationId, load)

load()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (questionnaire) => {
        return (_openBlock(), _createElementBlock("li", {
          key: questionnaire.id,
          class: _normalizeClass({ expanded: expandedQuestionnaireId.value === questionnaire.id })
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              href: "javascript: void(0)",
              onClick: () => toggleExpandedQuestionnaire(questionnaire.release.id, questionnaire.id),
              class: "icon toggle"
            }, [
              _createElementVNode("img", {
                src: expandedQuestionnaireId.value === questionnaire.id ? _unref(ICON_ARROW_DOWN) : _unref(ICON_ARROW_RIGHT)
              }, null, 8, _hoisted_5)
            ], 8, _hoisted_4),
            _createElementVNode("a", {
              href: "javascript: void(0)",
              onClick: () => toggleExpandedQuestionnaire(questionnaire.release.id, questionnaire.id),
              class: "name"
            }, _toDisplayString(questionnaire.name), 9, _hoisted_6),
            (_ctx.mode === 'check')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript: void(0)",
                  onClick: () => promptNewItem(questionnaire.release.id, questionnaire.id),
                  class: "icon add"
                }, [
                  _createElementVNode("img", { src: _unref(ICON_ADD) }, null, 8, _hoisted_8)
                ], 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionnaire.userQuestionnaires, (userQuestionnaire) => {
              return (_openBlock(), _createElementBlock("li", {
                key: userQuestionnaire.id
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("input", {
                      type: "radio",
                      name: `radio-${questionnaire.id}`,
                      id: `radio-${questionnaire.id}-${userQuestionnaire.pk}`,
                      onChange: (e) => onRadioChange(e, userQuestionnaire.pk),
                      checked: selectedUserQuestionnairePk.value === userQuestionnaire.pk
                    }, null, 40, _hoisted_11)
                  ]),
                  _createElementVNode("label", {
                    for: `radio-${questionnaire.id}-${userQuestionnaire.pk}`
                  }, _toDisplayString(userQuestionnaire.description), 9, _hoisted_12),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(userQuestionnaire.progress) + "% ", 1),
                  (_ctx.mode === 'check')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "icon trash",
                        onClick: () => removeItem(userQuestionnaire.pk)
                      }, [
                        _createElementVNode("img", { src: _unref(ICON_TRASH) }, null, 8, _hoisted_15)
                      ], 8, _hoisted_14))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ], 2))
      }), 128))
    ]),
    _createVNode(AppAlert, {
      show: promptForNewItem.value,
      "show-cancel": "",
      "button-label": "SPEICHERN",
      onOk: addNewItem,
      onCancel: cancelNewItem
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "form",
          onSubmit: _withModifiers(addNewItem, ["prevent"])
        }, [
          _createElementVNode("label", null, [
            _createTextVNode(" Bezeichnung "),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newItemName).value = $event)),
              autofocus: ""
            }, null, 512), [
              [_vModelText, newItemName.value]
            ])
          ]),
          _hoisted_17
        ], 40, _hoisted_16)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})